import { Link } from '@suntex.core/nav'

interface ExploreLinkProps {
  url: string
  title: string
  className?: string // Optional prop to customize the CSS classes
}

function ExploreLink({ url, title, className }: ExploreLinkProps) {
  return (
    <div className={`resources-item__title fw-bold ${className || ''}`}>
      <Link
        to={url}
        className={`${className || 'text-body'}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {title}
      </Link>
    </div>
  )
}

export default ExploreLink
